import { render, staticRenderFns } from "./CC_MY_BASE_edit.vue?vue&type=template&id=f06351ee&scoped=true"
import script from "./CC_MY_BASE_edit.vue?vue&type=script&lang=js"
export * from "./CC_MY_BASE_edit.vue?vue&type=script&lang=js"
import style0 from "./CC_MY_BASE_edit.vue?vue&type=style&index=0&id=f06351ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06351ee",
  null
  
)

export default component.exports